var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 66,
    viewBox: "0 0 56 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.031,
    y: 2.813,
    width: 52.375,
    height: 64.375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.09px)",
      height: "100%",
      width: "100%"
    },
    clipPath: "url(#no-calendar_svg__bgblur_0_40001055_47778_clip_path)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-calendar_svg__filter0_din_40001055_47778)",
    "data-figma-bg-blur-radius": 2.188,
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 65h34.563a6.719 6.719 0 006.718-6.719V19l-14-14H6.875a6.719 6.719 0 00-6.719 6.719V58.28A6.719 6.719 0 006.875 65z",
    fill: "url(#no-calendar_svg__paint0_linear_40001055_47778)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 5.156h27.217L48 19.065V58.28a6.563 6.563 0 01-6.563 6.563H6.876A6.563 6.563 0 01.312 58.28V11.72a6.563 6.563 0 016.563-6.563z",
    stroke: "#fff",
    strokeOpacity: 0.52,
    strokeWidth: 0.313
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-calendar_svg__filter1_d_40001055_47778)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.875 19h7.281l-14-14v7.281A6.719 6.719 0 0040.875 19z",
    fill: "url(#no-calendar_svg__paint1_linear_40001055_47778)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.78 18.844h-6.905a6.563 6.563 0 01-6.563-6.563V5.377L47.78 18.844z",
    stroke: "#fff",
    strokeOpacity: 0.52,
    strokeWidth: 0.313
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-calendar_svg__filter2_d_40001055_47778)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.156 28v-2h-2v2h-4a1 1 0 00-1 1v16a1 1 0 001 1h18a1 1 0 001-1V29a1 1 0 00-1-1h-4v-2h-2v2h-6zm-5 5h16v11h-16V33zm5.879 1.964l2.121 2.122 2.121-2.122 1.415 1.415L25.57 38.5l2.122 2.121-1.415 1.414-2.12-2.12-2.122 2.12-1.414-1.414 2.12-2.121-2.12-2.121 1.414-1.415z",
    fill: "url(#no-calendar_svg__paint2_linear_40001055_47778)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 26.156V28c0 .086.07.156.156.156h6c.087 0 .157-.07.157-.156v-1.844H29V28c0 .086.07.156.156.156h4c.466 0 .844.378.844.844v16a.844.844 0 01-.844.844h-18a.844.844 0 01-.844-.844V29c0-.466.378-.844.844-.844h4c.087 0 .157-.07.157-.156v-1.844H21zm-4.844 6.688A.156.156 0 0016 33v11c0 .086.07.156.156.156h16c.087 0 .157-.07.157-.156V33a.156.156 0 00-.157-.156h-16zm11.314 3.534l-2.01 2.012a.156.156 0 000 .22l2.01 2.011-1.193 1.194-2.01-2.011a.156.156 0 00-.17-.035l-.051.035-2.012 2.01-1.192-1.193 2.01-2.01a.157.157 0 000-.221l-2.01-2.012 1.192-1.193 2.012 2.011a.157.157 0 00.22 0l2.011-2.01 1.193 1.192z",
    stroke: "#fff",
    strokeOpacity: 0.52,
    strokeWidth: 0.313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-calendar_svg__paint0_linear_40001055_47778",
    x1: 3.219,
    y1: 7.899,
    x2: 45.538,
    y2: 43.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-calendar_svg__paint1_linear_40001055_47778",
    x1: 37.219,
    y1: -42.102,
    x2: 79.538,
    y2: -6.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#E6E5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-calendar_svg__paint2_linear_40001055_47778",
    x1: 47.327,
    y1: 26,
    x2: 56.336,
    y2: 41.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8F8F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-calendar_svg__filter0_din_40001055_47778",
    x: -2.031,
    y: 2.813,
    width: 52.375,
    height: 64.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.156,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_40001055_47778"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40001055_47778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.906
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_40001055_47778"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "12.80000114440918 12.80000114440918",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 6749
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    "in": "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_40001055_47778",
    "in": "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.1)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    "in": "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_40001055_47778"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "effect2_innerShadow_40001055_47778"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "color1"
  })), /*#__PURE__*/React.createElement("feBlend", {
    "in": "effect3_noise_40001055_47778",
    in2: "effect1_dropShadow_40001055_47778",
    result: "effect3_noise_40001055_47778"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-calendar_svg__filter1_d_40001055_47778",
    x: 27.156,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40001055_47778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_40001055_47778",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-calendar_svg__filter2_d_40001055_47778",
    x: 7.156,
    y: 21,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40001055_47778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_40001055_47778",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "no-calendar_svg__bgblur_0_40001055_47778_clip_path",
    transform: "translate(2.031 -2.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 65h34.563a6.719 6.719 0 006.718-6.719V19l-14-14H6.875a6.719 6.719 0 00-6.719 6.719V58.28A6.719 6.719 0 006.875 65z"
  })))));
}
export default SvgNoCalendar;